import { defineComponent as ne, watchEffect as ie, ref as W, toRef as oe, computed as V, h as i } from "vue";
import le from "./ghl-ui.es1104.js";
import { warnOnce as ae } from "./ghl-ui.es853.js";
import de from "./ghl-ui.es854.js";
import E from "./ghl-ui.es855.js";
import re from "./ghl-ui.es870.js";
import se from "./ghl-ui.es712.js";
import { createKey as h } from "./ghl-ui.es384.js";
import { pxfy as K, depx as o } from "./ghl-ui.es856.js";
import { useThemeClass as ce } from "./ghl-ui.es857.js";
import { isSlotEmpty as P, resolveWrappedSlot as f } from "./ghl-ui.es860.js";
import ue from "./ghl-ui.es1105.js";
import he from "./ghl-ui.es905.js";
import fe from "./ghl-ui.es906.js";
import { call as U } from "./ghl-ui.es876.js";
const me = Object.assign(Object.assign({}, E.props), {
  size: {
    type: String,
    default: "medium"
  },
  value: {
    type: [String, Number, Boolean],
    default: void 0
  },
  loading: Boolean,
  defaultValue: {
    type: [String, Number, Boolean],
    default: !1
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  round: {
    type: Boolean,
    default: !0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  checkedValue: {
    type: [String, Number, Boolean],
    default: !0
  },
  uncheckedValue: {
    type: [String, Number, Boolean],
    default: !1
  },
  railStyle: Function,
  rubberBand: {
    type: Boolean,
    default: !0
  },
  /** @deprecated */
  onChange: [Function, Array]
});
let p;
const Fe = ne({
  name: "Switch",
  props: me,
  setup(e) {
    process.env.NODE_ENV !== "production" && ie(() => {
      e.onChange && ae("switch", "`on-change` is deprecated, please use `on-update:value` instead.");
    }), p === void 0 && (typeof CSS < "u" ? typeof CSS.supports < "u" ? p = CSS.supports("width", "max(1px)") : p = !1 : p = !0);
    const {
      mergedClsPrefixRef: k,
      inlineThemeDisabled: b
    } = de(e), B = E("Switch", "-switch", le, ue, e, k), l = re(e), {
      mergedSizeRef: S,
      mergedDisabledRef: c
    } = l, w = W(e.defaultValue), $ = oe(e, "value"), u = se($, w), v = V(() => u.value === e.checkedValue), m = W(!1), n = W(!1), a = V(() => {
      const {
        railStyle: t
      } = e;
      if (t)
        return t({
          focused: n.value,
          checked: v.value
        });
    });
    function d(t) {
      const {
        "onUpdate:value": C,
        onChange: _,
        onUpdateValue: R
      } = e, {
        nTriggerFormInput: x,
        nTriggerFormChange: F
      } = l;
      C && U(C, t), R && U(R, t), _ && U(_, t), w.value = t, x(), F();
    }
    function H() {
      const {
        nTriggerFormFocus: t
      } = l;
      t();
    }
    function O() {
      const {
        nTriggerFormBlur: t
      } = l;
      t();
    }
    function A() {
      e.loading || c.value || (u.value !== e.checkedValue ? d(e.checkedValue) : d(e.uncheckedValue));
    }
    function I() {
      n.value = !0, H();
    }
    function M() {
      n.value = !1, O(), m.value = !1;
    }
    function j(t) {
      e.loading || c.value || t.key === " " && (u.value !== e.checkedValue ? d(e.checkedValue) : d(e.uncheckedValue), m.value = !1);
    }
    function L(t) {
      e.loading || c.value || t.key === " " && (t.preventDefault(), m.value = !0);
    }
    const z = V(() => {
      const {
        value: t
      } = S, {
        self: {
          opacityDisabled: C,
          railColor: _,
          railColorActive: R,
          buttonBoxShadow: x,
          buttonColor: F,
          boxShadowFocus: q,
          loadingColor: G,
          textColor: J,
          iconColor: Q,
          [h("buttonHeight", t)]: r,
          [h("buttonWidth", t)]: X,
          [h("buttonWidthPressed", t)]: Y,
          [h("railHeight", t)]: s,
          [h("railWidth", t)]: y,
          [h("railBorderRadius", t)]: Z,
          [h("buttonBorderRadius", t)]: ee
        },
        common: {
          cubicBezierEaseInOut: te
        }
      } = B.value;
      let N, D, T;
      return p ? (N = `calc((${s} - ${r}) / 2)`, D = `max(${s}, ${r})`, T = `max(${y}, calc(${y} + ${r} - ${s}))`) : (N = K((o(s) - o(r)) / 2), D = K(Math.max(o(s), o(r))), T = o(s) > o(r) ? y : K(o(y) + o(r) - o(s))), {
        "--n-bezier": te,
        "--n-button-border-radius": ee,
        "--n-button-box-shadow": x,
        "--n-button-color": F,
        "--n-button-width": X,
        "--n-button-width-pressed": Y,
        "--n-button-height": r,
        "--n-height": D,
        "--n-offset": N,
        "--n-opacity-disabled": C,
        "--n-rail-border-radius": Z,
        "--n-rail-color": _,
        "--n-rail-color-active": R,
        "--n-rail-height": s,
        "--n-rail-width": y,
        "--n-width": T,
        "--n-box-shadow-focus": q,
        "--n-loading-color": G,
        "--n-text-color": J,
        "--n-icon-color": Q
      };
    }), g = b ? ce("switch", V(() => S.value[0]), z, e) : void 0;
    return {
      handleClick: A,
      handleBlur: M,
      handleFocus: I,
      handleKeyup: j,
      handleKeydown: L,
      mergedRailStyle: a,
      pressed: m,
      mergedClsPrefix: k,
      mergedValue: u,
      checked: v,
      mergedDisabled: c,
      cssVars: b ? void 0 : z,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e,
      mergedDisabled: k,
      checked: b,
      mergedRailStyle: B,
      onRender: l,
      $slots: S
    } = this;
    l == null || l();
    const {
      checked: c,
      unchecked: w,
      icon: $,
      "checked-icon": u,
      "unchecked-icon": v
    } = S, m = !(P($) && P(u) && P(v));
    return i("div", {
      role: "switch",
      "aria-checked": b,
      class: [`${e}-switch`, this.themeClass, m && `${e}-switch--icon`, b && `${e}-switch--active`, k && `${e}-switch--disabled`, this.round && `${e}-switch--round`, this.loading && `${e}-switch--loading`, this.pressed && `${e}-switch--pressed`, this.rubberBand && `${e}-switch--rubber-band`],
      tabindex: this.mergedDisabled ? void 0 : 0,
      style: this.cssVars,
      onClick: this.handleClick,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyup: this.handleKeyup,
      onKeydown: this.handleKeydown
    }, i("div", {
      class: `${e}-switch__rail`,
      "aria-hidden": "true",
      style: B
    }, f(c, (n) => f(w, (a) => n || a ? i("div", {
      "aria-hidden": !0,
      class: `${e}-switch__children-placeholder`
    }, i("div", {
      class: `${e}-switch__rail-placeholder`
    }, i("div", {
      class: `${e}-switch__button-placeholder`
    }), n), i("div", {
      class: `${e}-switch__rail-placeholder`
    }, i("div", {
      class: `${e}-switch__button-placeholder`
    }), a)) : null)), i("div", {
      class: `${e}-switch__button`
    }, f($, (n) => f(u, (a) => f(v, (d) => i(he, null, {
      default: () => this.loading ? i(fe, {
        key: "loading",
        clsPrefix: e,
        strokeWidth: 20
      }) : this.checked && (a || n) ? i("div", {
        class: `${e}-switch__button-icon`,
        key: a ? "checked-icon" : "icon"
      }, a || n) : !this.checked && (d || n) ? i("div", {
        class: `${e}-switch__button-icon`,
        key: d ? "unchecked-icon" : "icon"
      }, d || n) : null
    })))), f(c, (n) => n && i("div", {
      key: "checked",
      class: `${e}-switch__checked`
    }, n)), f(w, (n) => n && i("div", {
      key: "unchecked",
      class: `${e}-switch__unchecked`
    }, n)))));
  }
});
export {
  Fe as default,
  me as switchProps
};
